import { ArrowDown, ArrowUp, ChevronsUpDown } from "lucide-react";

import { Button } from "../ui/button";

interface SortableHeaderProps<TSort extends string> {
  readonly label: string;
  readonly column: TSort;
  readonly sort: TSort;
  readonly dir: "asc" | "desc";
  /** First click sorts this column `firstDir`; clicking it again turns the order round. */
  readonly onSort: (column: TSort, dir: "asc" | "desc") => void;
  readonly firstDir?: "asc" | "desc";
}

/** A column title that sorts the table (the server does the sorting, so every page follows it). */
export function SortableHeader<TSort extends string>({
  label,
  column,
  sort,
  dir,
  onSort,
  firstDir = "asc",
}: SortableHeaderProps<TSort>) {
  const active = sort === column;
  const next = active ? (dir === "asc" ? "desc" : "asc") : firstDir;
  const Icon = !active ? ChevronsUpDown : dir === "asc" ? ArrowUp : ArrowDown;
  return (
    <Button
      variant="ghost"
      size="sm"
      className="-ms-3 h-8 text-xs font-medium uppercase tracking-wide data-[active=true]:text-foreground"
      data-active={active}
      onClick={() => onSort(column, next)}
      title={`Sort by ${label.toLowerCase()}`}
    >
      {label}
      <Icon className="size-3.5" aria-hidden="true" />
    </Button>
  );
}
